import { Shield, AlertTriangle } from "lucide-react";
import { useLocale } from "@/contexts/LocaleContext";

export function Footer() {
  const { t } = useLocale();
  return (
    <footer className="border-t border-border/30 bg-cyber-darker/50 backdrop-blur-xl">
      <div className="container mx-auto px-4 py-6">
        <div className="glass-card p-4 mb-6">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
            <div>
              <h4 className="text-sm font-semibold text-foreground mb-1">{t("footer.disclaimer_title")}</h4>
              <p className="text-xs text-muted-foreground leading-relaxed">
                {t("footer.disclaimer_text")}
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <div className="flex items-center gap-2">
            <Shield className="w-4 h-4 text-primary" />
            <span>{t("footer.brand")}</span>
          </div>
          <div className="flex items-center gap-4">
            <span>{t("footer.purpose")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
